(function () {
    'use strict';

    var module = angular.module('uwAgenda.global');
    module.directive('calendarRange', ['HelperService', 'AgendaFilterBroadcast', CalendarRangeDirectiveFn]);

    /* directive for handling calendar range input */
    function CalendarRangeDirectiveFn(HelperService, AgendaFilterBroadcast) {
        var directive = {
            link: link,
            scope: {
                dateFrom: '=',
                dateTo: '=',
                isRequired: '@?',
                onChange: '&?'
            },
            restrict: 'E',
            templateUrl: '/app/global/templates/rf-global-calendar-range.template.html'
        };
        return directive;

        function link(scope, element) {
            var listenerClear = null;

            var inputFrom = element.find("#from");
            var inputTo = element.find("#to");

            // picker
            var pickerFrom = inputFrom.eq(0).data('DateTimePicker');
            var pickerTo = inputTo.eq(0).data('DateTimePicker');

            // format
            var format = HelperService.getLocalDateFormat(false);


            activate();

            function activate() {
                // date to interact with picker
                scope.iFrom = scope.dateFrom;
                scope.iTo = scope.dateTo;

                // set placeholder
                inputFrom[0].placeholder = format;
                inputTo[0].placeholder = format;

                // options of picker
                scope.optionsFrom = {
                    locale: moment.locale(),
                    format: format,
                    showClear: true,
                    showTodayButton: true,
                    allowInputToggle: true
                };

                scope.optionsTo = {
                    useCurrent: false //important
                };

                angular.extend(scope.optionsTo, scope.optionsFrom);
                listen();
                

            } // activate


            function listen() {
                listenerClear = scope.$on(AgendaFilterBroadcast.AppointmentStateClear, function () {
                    scope.dateFrom = null;
                    scope.dateTo = null;
                    activate();
                });
                // on destroy
                scope.$on('$destroy', function () {
                    // unregister from broadcast
                    if (listenerClear) {
                        listenerClear();
                        listenerClear = null;
                    }
                });
            } // listen

            // connect them
            inputFrom.on("dp.change", function (e) {
                pickerTo.minDate(e.date);
            });

            inputTo.on("dp.change", function (e) {
                pickerFrom.maxDate(e.date);
                // set "from" also
             //   pickerFrom.date(e.date);
            });


            // if date changes
            scope.changed = function () {
                if (scope.iFrom) {
                    scope.dateFrom = scope.iFrom.local().format();
                } // if
                else {
                    scope.dateFrom = null;
                } // else 
                if (scope.iTo) {
                    scope.dateTo = scope.iTo.local().format();
                } // if
                else {
                    scope.dateTo = null;
                } // else 

                // call outside change-listener
                if (scope.onChange) {
                    scope.onChange({ from: scope.dateFrom, to: scope.dateTo });
                }
            };

            // on click show picker
            inputFrom.on("click", function (event) {
                pickerFrom.show();
            });

            inputTo.on("click", function (event) {
                pickerTo.show();
            });

            // destroy
            scope.$on('$destroy', function () {
                //scope.interact = null;
                format = null;
                scope.optionsFrom = null;
                scope.optionsTo = null;
                inputFrom.off("click");
                inputTo.off("click");
                inputFrom = null;
                inputTo = null;
                pickerFrom.destroy();
                pickerTo.destroy();
                pickerFrom = null;
                pickerTo = null;
            });

        }// link
    }

})();